import type { ReactNode } from 'react'

// PageToolbar — shared sticky toolbar container for top-level pages.
// Provides consistent padding, border, backdrop, and sticky position
// across Discover, Me, and any future list-style page. Pages supply
// content as children; the container owns the outer chrome.
export function PageToolbar({
  children,
  className = '',
  testId,
}: {
  children: ReactNode
  className?: string
  testId?: string
}) {
  return (
    <div
      className={`sticky top-[72px] z-20 flex flex-none flex-col gap-2 border-b border-[var(--xr-border-default)] bg-[var(--xr-bg-surface)] px-3 py-2 sm:px-5 md:top-0 ${className}`.trim()}
      data-testid={testId}
    >
      {children}
    </div>
  )
}
